import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  DETAIL_LOGIN,
  FIRST_TIME_BUYER_LINK,
  REGISTER_HERE,
} from '../../../brands/default/content/components/checkout';
import { setUserEmail } from '../../../redux/actions/email';
import { panel } from './UserPanelSetup';

const UserLoginTitle = ({ setActivePanel, vipPaywall, expressCheckout }) => {
  const dispatch = useDispatch();

  const linkAction = async (event) => {
    event.preventDefault();
    setActivePanel(panel.registration);
    dispatch(setUserEmail(''));
  };

  return (
    <>
      <div className="row details-title align-items-center">
        <div className="col details-title__left-block text-nowrap">
          {DETAIL_LOGIN}
        </div>
        {!expressCheckout && (
          <div className="col text-right details-title__right-block">
            <Link href="#">
              <a
                onClick={linkAction}
                onKeyDown={linkAction}
                role="link"
                tabIndex={0}
              >
                {vipPaywall ? REGISTER_HERE : FIRST_TIME_BUYER_LINK}
              </a>
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

UserLoginTitle.propTypes = {
  expressCheckout: PropTypes.bool,
  setActivePanel: PropTypes.func.isRequired,
  vipPaywall: PropTypes.bool,
};

export default UserLoginTitle;
